import { gql } from 'apollo-angular';

export const ValidateAppSumoTokenDocument = gql`
  query validateAppSumoToken($token: String!) {
    validateAppSumoToken(token: $token) {
      appSumoEmail
    }
  }
`;
